import { forwardRef, useEffect, useRef } from "react";

export const CheckBox = forwardRef(({ indeterminate, ...rest }, ref) => {
    const defaultRef = useRef(null);
    const resolvedRef = ref || defaultRef;

    useEffect(() => {
        if (resolvedRef.current) {
            resolvedRef.current.indeterminate = !!indeterminate;
        }
    }, [resolvedRef, indeterminate]);

    return (
        <input
            type="checkbox"
            title="Select"
            ref={resolvedRef}
            {...rest}
            className="rounded-full"
            style={{
                width: 20,
                height: 20,
                accentColor: "var(--doc-natural-primary-color)",
            }}
        />
    );
});

CheckBox.displayName = "CheckBox";
